<template>
  <a-modal
    :visible="activityVisible"
    width="702px"
    :mask-closable="false"
    :title="title"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #name>
        <a-input
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入服务活动名称',
                },
              ],
            },
          ]"
          placeholder="请输入服务活动名称"
        />
      </template>
      <template #flag>
        <a-input
          v-decorator="[
            'flag',
            {
              rules: [
                {
                  required: true,
                  message: '请输入服务活动标志，增加后不可修改',
                },
              ],
            },
          ]"
          placeholder="请输入服务活动标志，增加后不可修改"
          :disabled="flag!=''"
        />
      </template>
      <template #icon>
        <a-upload
          v-decorator="[
            'icon',
            {
              initialValue: [],
              rules: [{ required: true, message: '请上传图片' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".jpg,.png,.jpeg"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :data="{fileType:'img',}"
          :action="`${uploadUrl}system/upload`"
          :before-upload="beforeUpload"
        >
          <img
            v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('icon').length === 1 && $refs.basicForm.form.getFieldValue('icon')[0].status === 'done'"
            width="100"
            height="100"
            :src="$refs.basicForm.form.getFieldValue('icon')[0].url"
            alt="avatar"
          >
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </template>
      <template #type>
        <a-select
          v-decorator="[
            'type',
            { rules: [{ required: true, message: '请选择活动类型' }] },
          ]"
          placeholder="请选择活动类型"
        >
          <a-select-option
            v-for="item in typeData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </template>
      <template #summary>
        <a-textarea
          v-decorator="[
            'summary',
            { rules: [{ required: true, message: '请输入' }] },
          ]"
          rows="3"
          placeholder="请输入"
          maxlength="150"
        />
      </template>
      <template #report_html>
        <a-textarea
          v-decorator="[
            'report_html',
            { rules: [{ required: true, message: '请输入报告渲染代码' }] },
          ]"
          rows="3"
          placeholder="请输入报告渲染代码"
          maxlength="150"
        />
      </template>
      <template #sort>
        <a-input-number
          v-decorator="[
            'sort',
            { rules: [{ required: true, message: '请输入排序' }] },
          ]"
        />
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import { formData } from '../data/index';
export default {
  props: ['activityVisible', 'title', 'btnIsLoading', 'flag'],
  data() {
    return {
      formData,
      typeData: [
        {id: '0', name: '常规报告'},
        {id: '1', name: '需定位报告'},
      ],
      loading: false,
    };
  },
  async mounted() {

  },

  methods: {
    normFile(e) {
      console.log('TCL: normFile -> e', e);
      if (e && e.file.status === 'uploading') {
        this.loading = true;
      }
      if(e && e.file.status === 'done'){
        const fileList = [{
          uid: e.file.response.data.id,
          status: 'done',
          name: 'img',
          url: e.file.response.data.url,
        }];
        this.loading = false;
        return fileList;
      }
      return e.fileList;
    },
    // 上传前
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('图片小于10M！');
      }
      return isLt2M;
    },
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
  .textarea {
    font-size: 12px;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
    position: relative;
    top: -37px;
    right: -550px;
  }
}
</style>
